import JEEndorsements from "./Endorsements";
export default JEEndorsements;
